export const firstNonEmpty = (...values: (string | null | undefined)[]) =>
  values.find(v => v != null && v !== '') ?? '';
